export default __webpack_public_path__ + "static/media/creative-home.ea801ecb.png";